
import { AxiosResponse } from 'axios';
import { fetchApi } from '../../../../redux/actions/fetch-actions';
import {
APIEndpoints,
APIMethods
} from '../../../../types/fetch/fetch-types';
import { AsyncPromiseHelper } from '../../../../utils/async-await-helper/AsyncPromiseHelper';
import { ResourceActions } from './resourceHub.actions';


export class ResourceActionsAsync {

  /**
  * @description fetch all the resources.
  */
  static getAllResources(userType: string) {
      return async (dispatch: any) => {
        const [result, error] = await AsyncPromiseHelper<AxiosResponse>(
          dispatch(
              fetchApi({
                url: `resources/?userType=${userType}` ,
                endpoint: APIEndpoints.DASHBOARD,
                method: APIMethods.GET,
              })
          )
        );
        if (error) {
          return Promise.reject(error);
        }
        const { data } = result;
        dispatch(ResourceActions.updateAllResources(data));
        return Promise.resolve(result);
      };
    }
    
   /**
   * Gets only a sigular resource based on the given id
   * @param id
   */
  static getResource(id: any) {
    return async (dispatch: any) => {
      const [result, error] = await AsyncPromiseHelper<AxiosResponse>(
        dispatch(
          fetchApi({
            url: `resources/${id}`,
            endpoint: APIEndpoints.DASHBOARD,
            method: APIMethods.GET,
          })
        )
      );
      if (error) {
        return Promise.reject(error);
      }
      const {data}  = result;
      dispatch(ResourceActions.updateResource(data));
      return Promise.resolve(result);
    };
  }
}